angular.module('storefrontApp')
    .component('vcCheckoutWizard', {
        transclude: true,
        templateUrl: 'themes/assets/js/checkout/checkout-wizard.tpl.html',
        bindings: {
            wizard: '=',
            loading: '=',
            onFinish: '&?',
            onInitialized: '&?',
        },
        controller: ['$scope', function ($scope) {
            const ctrl = this;

            ctrl.wizard = ctrl;
            ctrl.steps = [];

            ctrl.goToStep = function (step) {
                if (angular.isString(step)) {
                    step = _.find(ctrl.steps, function (x) { return x.name === step; });
                }

                if (step && !_.isEqual(ctrl.currentStep, step) && step.canEnter) {
                    if (!step.final) {
                        step.isActive = true;

                        if (ctrl.currentStep) {
                            ctrl.currentStep.isActive = false;
                        }
                        ctrl.currentStep = step;
                    } else if (ctrl.onFinish) {
                        ctrl.onFinish();
                    }
                }
            };

            ctrl.nextStep = function () {
                if (
                    (!angular.isFunction(ctrl.currentStep.validate) || ctrl.currentStep.validate())
                    && ctrl.currentStep.nextStep
                ) {
                    if (ctrl.currentStep.onNextStep) {
                        // evaluate onNextStep function
                        const promise = ctrl.currentStep.onNextStep();

                        // For promise function need to delay going to next step
                        if (promise && angular.isFunction(promise.then)) {
                            promise.then(function () {
                                ctrl.goToStep(ctrl.currentStep.nextStep);
                            });
                        } else {
                            ctrl.goToStep(ctrl.currentStep.nextStep);
                        }
                    } else {
                        ctrl.goToStep(ctrl.currentStep.nextStep);
                    }
                }
            };

            ctrl.prevStep = function () {
                ctrl.goToStep(ctrl.currentStep.prevStep);
            };

            function rebuildStepsLinkedList(steps) {
                let nextStep;

                for (let i = steps.length; i > 0; i -= 1) {
                    steps[i].prevStep = undefined;
                    steps[i].nextStep = undefined;

                    if (nextStep && !steps[i].disabled) {
                        nextStep.prevStep = steps[i];
                    }

                    if (!steps[i].disabled) {
                        steps[i].nextStep = nextStep;
                        nextStep = steps[i];
                    }
                }
            }

            ctrl.addStep = function (step) {
                ctrl.steps.push(step);

                $scope.$watch(function () {
                    return step.disabled;
                }, function () {
                    rebuildStepsLinkedList(ctrl.steps);
                });

                rebuildStepsLinkedList(ctrl.steps);

                if (!ctrl.currentStep) {
                    ctrl.goToStep(step);
                }

                if (step.final && ctrl.onInitialized) {
                    ctrl.onInitialized();
                }
            };
        }],
    });
